import { render, staticRenderFns } from "./OutlierChart.vue?vue&type=template&id=2c887bf3"
import script from "./OutlierChart.vue?vue&type=script&setup=true&lang=js"
export * from "./OutlierChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OutlierChart.vue?vue&type=style&index=0&id=2c887bf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports